import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Only treat the hash as an anchor if it's a valid CSS id selector.
    // OAuth callbacks leave hashes like `#access_token=…&state=…` which are
    // NOT valid selectors and would throw inside `querySelector`.
    const isAnchor = hash && /^#[A-Za-z][\w-]*$/.test(hash);
    if (isAnchor) {
      try {
        const el = document.querySelector(hash);
        if (el) {
          setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
          return;
        }
      } catch {
        /* ignore invalid selectors (e.g. OAuth hash params) */
      }
    }
    window.scrollTo({ top: 0, left: 0 });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
